<div
	class="flex flex-wrap h-auto md:w-[320px] md:h-full justify-center gap-x-3 lg:mx-2 shadow-[0px_10px_15px_2px_#00000010] rounded-[40px]"
>
	<div class="pb-[20px]">
		@let divWidth = 320;
		<div
			[style.--div-w.px]="divWidth"
			class="relative h-[280px] w-[--div-w] bg-auto rounded-tl-[40px] rounded-tr-[40px] bg-center mx-auto cursor-pointer overflow-hidden"
			(click)="mainService.handleButtonClick($event, offer())"
		>
			@if (offer().multimedia?.length > 0 && !!offer().multimedia[0]?.multimedia.url) {
				<img
					[alt]="offer().product.name"
					[ngSrc]="offer().multimedia[0]?.multimedia.url | optimizedImage: { width: divWidth }"
					class="h-full object-cover"
					fill
					loading="lazy"
				/>
			} @else {
				<div class="h-full object-cover">
					<p
						class="flex justify-center items-center h-full border-mainColor border-1 rounded-tl-[40px] rounded-tr-[40px] font-bold text-mainColor"
					>
						Brak zdjęcia
					</p>
				</div>
			}
			@let promotionWidth = 120;
			@if (!!offer().promotion?.catalog.multimedia) {
				<img
					[ngSrc]="offer().promotion?.catalog.multimedia | optimizedImage: { width: promotionWidth }"
					height="30"
					[width]="promotionWidth"
					alt="Promocja"
					class="absolute top-8 w-1/2"
					loading="lazy"
				/>
			}
		</div>
		<div class="flex-grow p-2 text-mainColor px-[20px]">
			<div class="h-[80px]">
				<div
					class="product-name font-extrabold text-mainColor uppercase cursor-pointer max-w-[250px] overflow-hidden"
					(click)="mainService.handleButtonClick($event, offer())"
				>
					{{ offer().product.name }}
				</div>
				<div class="text-base text-mainColor">
					{{ locations() }}
				</div>
			</div>
			<div>
				<div class="inline-block mt-2 min-w-18">
					<i class="fa-solid fa-calendar-days mr-2"></i>
					{{ offer().stop.departureDatetime | polishDate }} - {{ offer().stop.returnDatetime | polishDate }}
				</div>
				<div class="flex mt-2 min-w-18 justify-between items-center">
					<span>
						<i class="fa-solid fa-utensils mr-2"></i>
						{{ offer().board.name }}
					</span>
					<i
						class="fas fa-info-circle cursor-pointer hover:text-accentColor transition-colors"
						(click)="displayMoreFoodInfo(offer())"
						#boardsTooltip
					></i>
				</div>
				<div class="inline-block mt-2 min-w-18">
					@switch (offer().transport.kind) {
						@case (TransportKind.COUCH) {
							<i class="fa-solid fa-bus mr-2"></i>
							Autokarem
						}
						@case (TransportKind.PLANE) {
							<i class="fa-solid fa-plane mr-2"></i>
							Samolotem
						}
						@case (TransportKind.OWN_TRANSPORT) {
							<i class="fa-solid fa-car mr-2"></i>
							Dojazd własny
						}
					}
				</div>
			</div>
		</div>
	</div>
	<div class="w-full">
		<div class="flex flex-col items-end justify-center w-full px-[20px]">
			@let isPromo = offer().catalogPrice && offer().catalogPrice !== offer().fullPrice;
			<p
				[ngClass]="{
					'line-through': offer().fullPrice,
					'text-mainColor': isPromo,
					'text-transparent': !isPromo,
				}"
			>
				{{ offer().catalogPrice | price }}/os
			</p>

			<p class="text-red text-lg font-extrabold">{{ offer().fullPrice | price }}/os</p>
		</div>
	</div>
	<a
		[href]="
			mainService.getOfferUrl(offer()) +
			'?' +
			mainService.getUrlParams(offer(), 'url', offersFacade.selected$ | async)
		"
		(click)="mainService.handleButtonClick($event, offer())"
		class="!rounded-3xl border-[1px] bg-accentColor hover:bg-accentHoverColor justify-evenly text-white font-extrabold text-base md:text-lg py-2 my-3 uppercase px-4 text-center w-[80%]"
		>ZOBACZ OFERTĘ</a
	>
</div>
